var map = {
	"./common/Handlers": 76196,
	"./complementary/Handlers": 36670,
	"./course/Handlers": 67247,
	"./customer/Handlers": 98291,
	"./dashboard/Handlers": 21048,
	"./discount/Handlers": 12465,
	"./download/Handlers": 19707,
	"./employee/Handlers": 38125,
	"./login/Handlers": 3511,
	"./menu/Handlers": 43148,
	"./modifier/Handlers": 63053,
	"./offer/Handlers": 37516,
	"./product/Handlers": 19207,
	"./report/Handlers": 81666,
	"./reward/Handlers": 14,
	"./service/Handlers": 23308,
	"./setting/Handlers": 75205,
	"./stock/Handlers": 96757,
	"./supplier/Handlers": 4481,
	"./table/Handlers": 72933,
	"./transaction/Handlers": 67813,
	"./user/Handlers": 95214,
	"./warranty/Handlers": 86442
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9784;